import * as React from "react";
import ActionDropdown from "views/components/common/ActionDropdown";
import { IconButton, Spinner } from "components/common";
const AggregationWidgetExportDropdown = ({
  children,
  isExporting
}) => {
  if (isExporting) return /* @__PURE__ */ React.createElement(Spinner, { text: "" });
  const widgetActionDropdownCaret = /* @__PURE__ */ React.createElement(IconButton, { name: "download", title: "Export widget", showTooltip: false });
  return /* @__PURE__ */ React.createElement(ActionDropdown, { element: widgetActionDropdownCaret, header: "Export to file" }, children);
};
export default AggregationWidgetExportDropdown;
